<template>
  <SectionListIcon014
    v-if="contextData"
    :title="contextData.title"
    :description="contextData.description"
    :number-of-line="contextData.numberOfLine"
    :items="contextItems"
    :theme="theme"
  />
</template>

<script setup lang="ts">
  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface IItem {
    name: string;
    description?: string;
    thumbnail: string;
  }

  interface IListFeaturesStackedData {
    title: string;
    description?: string;
    numberOfLine: 2 | 3 | 4;
    items: IItem[];
  }

  interface IListFeaturesStacked {
    component: 'list-features-stacked';
    meta: {
      navigable?: string;
    };
    data: IListFeaturesStackedData;
  }

  type IProps = ISuiteProps<IListFeaturesStacked>;

  const props = defineProps<IProps>();

  const solutionsStore = useSolutionsStore();
  const { themeStyle } = storeToRefs(solutionsStore);

  const { provideSuiteThumbnailUrl } = useImagePath(props.urlConnector);

  const contextData = computed(
    (): IListFeaturesStackedData => props.suiteData.data
  );

  const contextItems = computed((): IItem[] =>
    contextData.value.items.map((item) => ({
      ...item,
      thumbnail: provideSuiteThumbnailUrl(item.thumbnail),
      description: undefined,
      descriptionHtml: item.description,
    }))
  );

  const theme = computed((): TTheme => {
    switch (themeStyle.value) {
      case 'sustainable':
        return 'green';
      case 'connected':
        return 'cyan';
      case 'ai':
        return 'purple';
      case 'operations':
        return 'yellow';
      default:
        return 'blue';
    }
  });

  export type { IItem, IListFeaturesStacked, IListFeaturesStackedData };
</script>
